import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import AsmLeadForm from '../../../../components/LeadForm/AsmLeadForm';

function AziziMilanAsm({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const images = [
        "/assets/images/projects/azizi-milan/1.webp",
        "/assets/images/projects/azizi-milan/2.webp",
        "/assets/images/projects/azizi-milan/3.webp",
        "/assets/images/projects/azizi-milan/4.webp"
    ];

    const poster = "/assets/images/projects/azizi-milan/1.webp";
    const webm = "/assets/images/projects/azizi-milan/hero.webm";
    const mp4 = "/assets/images/projects/azizi-milan/hero.mp4";

    return (
        <>
            <div>
                {/* <NoiseBackground /> */}
                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/c8as/azizi/milan"
                        : "/c8as/azizi/milan/ar"
                    }
                />
                {/* LIMITED TIME OFFER */}
                <div className="padding-container my-5 py-5">
                    <Countdown />
                </div>

                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar"
                        ? (
                            <h1 className="text-center px-2 my-1 text-xl">
                                <span className="text-2xl bounce-text secondary-text">
                                    دبي بطابع إيطالي
                                </span>
                                – أسلوب الحياة الإيطالي في قلب City of Arabia                                {/* <span className="text-2xl bounce-text secondary-text" id="price">
                                    {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "68,000 درهم"
                                            : (userInfo?.countryCode === "FR" || userInfo?.countryCode === "fr")
                                                ? "€18,000"
                                                : "$18,000"
                                    }
                                </span> */}
                                {/* فقط! */}
                            </h1>
                        ) : (
                            <>
                                <h1 className="text-center px-2 my-1 pb-3 text-xl">
                                    <span className="text-2xl bounce-text secondary-text">
                                        Dubai Meets Italy
                                    </span>
                                    - Iconic Italian Living at City of Arabia
                                </h1>
                                {/* <h1 className="text-center px-2 my-1 pb-3 text-xl">
                                    <span className="font-bold primary-text">
                                        Limited-time offer
                                    </span>
                                    : Reserve your unit now and get a free furnishing voucher!
                                </h1>
                                <h1 className="text-center px-2 my-1 pb-3 text-xl">
                                    Register today to secure your dream home&nbsp;
                                    <span className="font-bold primary-text">
                                        before the official launch
                                    </span>!
                                </h1> */}
                            </>
                        )
                    }
                </div>
            </div >
            {/* IMAGES */}
            <div className="flex w-full justify-center">
                <video
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    preload="auto"
                    poster={poster}
                    width="350"
                    height="350"
                    className={`max-w-[350px] rounded-2xl`}
                >
                    <source src={webm} type="video/webm" />
                    <source src={mp4} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            
            {/* < ImageSlider images={images} /> */}
            <div className="p-5 my-5">
                {/* LEAD FORM */}
                <AsmLeadForm
                    developer="Azizi"
                    project="Milan"
                    leadType="Apartment"
                    language={language === "ar" ? "Arabic" : "English"}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                />
                {/* <LeadForm
                    developer="Azizi"
                    project="Venice"
                    leadType="Apartment"
                    language={currentLang?.name}
                    client={true}
                    clientId={clientId}
                    clientEmail={clientMail}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "Retail"]}
                /> */}
            </div>
            <Footer />
        </>
    );
}

export default AziziMilanAsm;
